import builders from 'turtle/bin/commands/build';
import setup from 'turtle/bin/commands/setup';

export const setupIOS = setup.ios;
export const setupAndroid = setup.android;

export const buildIOS = builders.ios;
export const buildAndroid = builders.android;
